import { add, remove } from "@fluorescent/dom";
import { delayOffset } from "@/lib/animation";

const selectors = {
  mainContent: ".animation--item",
  footerItems: ".animation--container > *",
};

const classes = {
  isVisible: "is-visible",
};

export default node => {
  function animate() {
    // Add the animation delay offset variables
    delayOffset(node, [selectors.mainContent]);
    delayOffset(node, [selectors.footerItems]);

    // Trigger the reveal animation when the quick view is opened.
    setTimeout(() => {
      add(node, classes.isVisible);
    }, 0);
  }

  function reset() {
    remove(node, classes.isVisible);
  }

  return {
    animate,
    reset,
  };
};
